import * as PropTypes from "prop-types";
import {connect} from 'react-redux';
import {Icon} from "@mc/mc-legacy";
import {Component} from "react";
import * as React from "react";
import './ObjednavkaPotvrzeniRow.scss';

/**
 * Barevný pruh zobrazující potvrzení odeslání/zrušení objednávky.
 */
class ObjednavkaPotvrzeniRow extends Component {

    static propTypes = {
        text: PropTypes.string.isRequired, // text zobrazený vedle ikony
        success: PropTypes.bool, // zda byla objednávka odeslána (true) nebo zrušena (false), implicitně false (zrušena)
    };

    render() {
        const {text, success} = this.props;
        return <div className={`objednavka-potvrzeni-row${success ? " success" : " fail"}`}>
            <Icon icon={success ? "check-circle" : "times-circle"}/> {text}
        </div>
    }
}

export default connect()(ObjednavkaPotvrzeniRow);
